<template>
	<div class="order-details-box">
		<header class="lmy-header lmy-header-w">
			<i class="iconfont icon-yuyin" @click="Back"></i>
	        订单详情
	  </header>
		<div class="infinite-loading-containers" style="margin-top:1.2rem" v-if="isLoading">
			<i class="loading-defaults"></i>
		</div>
		<div v-if="!isLoading&&bookInfo.OrderType==0">
      <div class="top">
        <div class="txt" v-if="bookInfo.Status === 8">
          <p class="order-type">交易关闭</p>
          <p>订单已经关闭</p>
          <div class="btn-box">
            <p class='active btn' @click="bookAgain()">再次预定</p>
          </div>
        </div>
        <div class="txt"  v-if="(bookInfo.PaymentType == 0||bookInfo.PaymentType == 1)&&(bookInfo.Status == 9||bookInfo.Status == 10||bookInfo.Status == 2)" >
          <p class="order-type">等待付款</p>
          <p>由于价格变动频繁,请在10分钟内完成支付</p>
          <div class="btn-box">
            <p class='active btn' @click="routeToPay(bookInfo)" >立即支付</p>
            <p class='active btn' @click="bookAgain()">再次预定</p>
            
          </div>
        </div>
        <div class="txt" v-if="bookInfo.PaymentType == 3" >
          <p class="order-type">交易成功</p>
          <p>支付完成</p>
          <div class="btn-box" >
            <p class='active btn' v-if="!bookInfo.IsInvoice && bookInfo.IsCanInvoice" @click.stop="openInvoice()">发票报销</p>
            <p class='active btn' v-if="bookInfo.IsInvoice" @click.stop="$router.push('/invoiceDetails?orderNo='+bookInfo.OrderNO+'&from=myOrder')">查看发票</p>
            <p class='active btn' @click="bookAgain()">再次预定</p>
          </div>
        </div>
      </div>
      <div class="middle">
        <div class="order-price flow">
          <p>总计：<span class="sym">￥</span><span class="num">{{bookInfo.TotalAmount}}</span></p>
        </div>
      </div>
      <div class="bottom">
              <div class="details">
                  <p class="title">订单信息</p>
                  <ul>
                      <li>
                          <span class="lable">订单号：</span>
                          <span>{{bookInfo.OrderNO}}</span>
                      </li>
                      <li>
                          <span class="lable">产品名称：</span>
                          <span>{{bookInfo.HotelName}}</span>
                      </li>
                      <li>
                          <span class="lable">产品类型：</span>
                          <span>{{bookInfo.RoomName}} ({{bookInfo.RoomCount}}间)</span>
                      </li>
                      <li>
                          <span class="lable">产品政策：</span>
                          <span>{{bookInfo.RPName||'无'}}</span>
                      </li>
                      <li> 
                          <span class="lable">入离时间：</span>
                          <span>{{bookInfo.CheckIn|dateYYMMDD}} 到 {{bookInfo.CheckOut|dateYYMMDD}}</span>
                      </li>
                      <li>
                          <span class="lable">特殊要求：</span>
                          <span>{{bookInfo.Remark||'无'}}</span>
                      </li>
                      <li>
                          <span class="lable">取消条款：</span>
                          <span>{{bookInfo.CancelPolicy||'无'}}</span>
                      </li><li>
                          <span class="lable">下单时间：</span>
                          <span>{{bookInfo.BookingOn|dateLong}}</span>
                      </li>
                  </ul>
                  <p class="title" >住客信息</p>
                    <ul>
                        <li v-for="(user,index) in bookInfo.Guest" :key="index">
                            <span class="lable">入住人{{index+1}}：</span>
                            <span>{{user.FirstName}}{{user.LastName}}</span>
                        </li>
                        <li>
                            <span class="lable">联系电话：</span>
                            <span>{{bookInfo.Phone||'无'}}</span>
                        </li>
                    </ul>
                    <p class="title">酒店信息</p>
                  <ul>
                      <li>
                          <span class="lable">酒店地址：</span>
                          <span>{{bookInfo.HotelAddress||'无'}}</span>
                      </li>
                      <li>
                          <span class="lable">酒店电话：</span>
                          <span>{{bookInfo.HotelPhone||'无'}}</span>
                      </li>
                  </ul>
              </div>
      </div>
    </div>
    <div v-if="!isLoading&&bookInfo.PackageType==1">
      <div class="top">
        <div class="txt" v-if="(bookInfo.Status == 10||bookInfo.Status == 11)&&bookInfo.NeedPay">
          <p class="order-type">等待付款</p>
          <p>由于价格变动频繁,请在30分钟内完成支付</p>
          <div class="btn-box">
            <p class='active btn' @click="routeToPay(bookInfo)">立即支付</p>
            <p class="active btn" @click="cancel(bookInfo,$event)">取消</p>
          </div>
        </div>
        <div class="txt" v-if="(bookInfo.Status == 10||bookInfo.Status == 11)&&!bookInfo.NeedPay">
          <p class="order-type">支付成功</p>
          <p>订单等待确认</p>
          <div class="btn-box" v-if="bookInfo.CanCancel">
            <p class="active btn" @click="cancel(bookInfo,$event)">申请退款</p>
          </div>
        </div>
        <div class="txt" v-if="bookInfo.Status == 20">
          <p class="order-type">支付成功</p>
          <p>订单已确认</p>
          <div class="btn-box" v-if="bookInfo.CanCancel">
            <p class="active btn" @click="cancel(bookInfo,$event)">申请退款</p>
          </div>
        </div>
        <div class="txt" v-if="bookInfo.Status == 40">
          <p class="order-type">交易成功</p>
          <p>订单已完成</p>
          <div class="btn-box" v-if="bookInfo.CanCancel">
            <p class="active btn" @click="cancel(bookInfo,$event)">申请退款</p>
          </div>
        </div>
        <div class="txt" v-if="bookInfo.Status == 50">
          <p class="order-type">交易关闭</p>
          <p>订单已经关闭</p>
        </div>
      </div>

      <div class="middle">
        <div class="order-price flow">
          <p>订单金额：<span class="sym">￥</span><span class="num">{{bookInfo.TotalAmount}}</span></p>
        </div>
      </div>
		  <div class="bottom">
            <div class="details">
                <p class="title">订单信息</p>
                <ul>
                    <li>
                        <span class="lable">订单号：</span>
                        <span>{{bookInfo.QGOrderNo}}</span>
                    </li>
                    <li>
                        <span class="lable">产品名称：</span>
                        <span>{{bookInfo.ProductName}}</span>
                    </li>
                    <li>
                        <span class="lable">产品类型：</span>
                        <span>{{bookInfo.SKUName}} ({{bookInfo.Count}}份)</span>
                    </li>
                    <li> 
                        <span class="lable">出发时间：</span>
                        <span>{{bookInfo.CheckIn|dateToYMDline}}</span>
                    </li>
                    <li>
                        <span class="lable">特殊要求：</span>
                        <span>{{bookInfo.SpecialRemark||'无'}}</span>
                    </li>
										<li>
                        <span class="lable">取消条款：</span>
                        <span>{{bookInfo.PkgCancelPolicy.CancelPolicy||'无'}}</span>
                    </li><li>
                        <span class="lable">下单时间：</span>
                        <span>{{bookInfo.CreateDate | dateLong}}</span>
                    </li>
                </ul>
            </div>
      </div>
	
			<div class="bottom">
				<div class="details">
					<p class="title">客人信息</p>
					<ul v-for="(user,index) in bookInfo.Guests" :key="index">
						<li >
							<span class="lable">入住人{{bookInfo.Guests.length>1?index+1:''}}：</span>
							<span>{{user.CnName}}</span>
						</li>
					</ul>
          <ul>
            <li>
              <span class="lable">联系电话：</span>
              <span>{{bookInfo.ReceiverPhone||'无'}}</span>
            </li>
          </ul>
				</div>
			</div>

      <div class="bottom" v-if="!isLoading&&bookInfo.SkuPieces&&bookInfo.SkuPieces.length>0">
				<div class="details">
					<p class="title">产品包含</p>
					<div v-for="S in bookInfo.SkuPieces" style="font-size: 0.3rem;padding-bottom: 0.1rem;" >{{S}}</div>
				</div>
			</div>
    </div>
    <div v-if="!isLoading&&bookInfo.PackageType==2">
      <div class="top">
        <div class="txt" v-if="bookInfo.Status == 10&&bookInfo.NeedPay">
          <p class="order-type">等待付款</p>
          <p>由于价格变动频繁,请在30分钟内完成支付</p>
          <div class="btn-box">
            <p class='active btn' @click="routeToPay(bookInfo)" >立即支付</p>
            <p class="active btn" @click="cancel(bookInfo,$event)">取消</p>
          </div>
        
        </div>
        <div class="txt" v-if="bookInfo.Status == 10&&!bookInfo.NeedPay">
          <p class="order-type">支付成功</p>
          <p>订单等待预约</p>
          <div class="btn-box" v-if="bookInfo.CanCancel">
            <p class="active btn" @click="cancel(bookInfo,$event)">申请退款</p>
          </div>
        </div>
        <div class="txt" v-if="bookInfo.Status == 11">
          <p class="order-type">支付成功</p>
          <p>订单预约中</p>
          <div class="btn-box" v-if="bookInfo.CanCancel">
            <p class="active btn" @click="cancel(bookInfo,$event)">申请退款</p>
          </div>
        </div>
        <div class="txt" v-if="bookInfo.Status == 12">
          <p class="order-type">支付成功</p>
          <p>订单部分预约</p>
          <div class="btn-box" v-if="bookInfo.CanCancel">
            <p class="active btn" @click="cancel(bookInfo,$event)">申请退款</p>
          </div>
        </div>
        <div class="txt" v-if="bookInfo.Status == 20">
          <p class="order-type">支付成功</p>
          <p>订单已预约</p>
          <div class="btn-box" v-if="bookInfo.CanCancel">
            <p class="active btn" @click="cancel(bookInfo,$event)">申请退款</p>
          </div>
        </div>
        <div class="txt" v-if="bookInfo.Status == 40">
          <p class="order-type">交易成功</p>
          <p>订单已完成</p>
          <div class="btn-box" v-if="bookInfo.CanCancel">
            <p class="active btn" @click="cancel(bookInfo,$event)">申请退款</p>
          </div>
        </div>
        <div class="txt" v-if="bookInfo.Status == 50">
          <p class="order-type">交易关闭</p>
          <p>订单已经关闭</p>
        </div>
      </div>
      <!-- <div class="bottom" style="margin-top: .5rem;">
				<div class="details">
					<p class="title">{{bookInfo.ProductName}}</p>
					<div style="font-size: 0.3rem;padding-bottom: 0.1rem;" >{{bookInfo.SKUName}}</div>
          <div class="order-price" style="padding: 0.2rem 0;">
            <div style="padding-bottom: 0.1rem;">订单金额：<span class="sym">￥</span><span class="num">{{bookInfo.TotalAmount}}</span></div>
            <div style="padding-bottom: 0.1rem;">份数：{{bookInfo.Count}}份</div>
            <div style="padding-bottom: 0.1rem;">有效期至：{{bookInfo.EndActiveDate|dateToYMDline}}</div>
            <div style="margin-left: 5em;color:#eb3941;font-weight:bold;position: relative;">
                <span style="position: absolute;top: 0;left: -5em;">适用限制：</span>
                {{bookInfo.TimeLimitTypeName}}
            </div>
          </div>
				</div>
			</div> -->
      <div class="middle">
        <div class="order-price flow">
          <p>订单金额：<span class="sym">￥</span><span class="num">{{bookInfo.TotalAmount}}</span></p>
        </div>
      </div>
      <div class="bottom">
            <div class="details">
                <p class="title">订单信息</p>
                <ul>
                    <li>
                        <span class="lable">订单号：</span>
                        <span>{{bookInfo.QGOrderNo}}</span>
                    </li>
                    <li>
                        <span class="lable">产品名称：</span>
                        <span>{{bookInfo.ProductName}}</span>
                    </li>
                    <li>
                        <span class="lable">产品类型：</span>
                        <span>{{bookInfo.SKUName}}</span>
                    </li>
                    <li>
                        <span class="lable">份数：</span>
                        <span>{{bookInfo.Count}}份</span>
                    </li>
                    <li> 
                        <span class="lable">有效期至：</span>
                        <span>{{bookInfo.EndActiveDate|dateToYMDline}}</span>
                    </li>
                    <li> 
                        <span class="lable">适用限制：</span>
                        <span style="font-weight:bold; color:#eb3941;">{{bookInfo.TimeLimitTypeName}}</span>
                    </li>
                    <li>
                        <span class="lable">特殊要求：</span>
                        <span>{{bookInfo.SpecialRemark||'无'}}</span>
                    </li>
										<li>
                        <span class="lable">取消条款：</span>
                        <span>{{bookInfo.PkgCancelPolicy.CancelPolicy||'无'}}</span>
                    </li>
                    <li>
                        <span class="lable">下单时间：</span>
                        <span>{{bookInfo.CreateDate | dateLong}}</span>
                    </li>
                </ul>
            </div>
      </div>
      <div class="bottom" v-if="!isLoading&&bookInfo.SkuPieces&&bookInfo.SkuPieces.length>0">
				<div class="details">
					<p class="title">产品包含</p>
					<div v-for="S in bookInfo.SkuPieces" style="font-size: 0.3rem;padding-bottom: 0.1rem;" >{{S}}</div>
				</div>
			</div>
      <div class="bottom" v-if="!isLoading&&bookInfo.SubOrders&&bookInfo.SubOrders.length>0">
				<div class="details">
					<p class="title" style="margin: 0.6rem 0;">预约码</p>
          <div class="appointment" v-for="sub,index in bookInfo.SubOrders">
            <span class="code">{{sub.Code}}</span>
            <span class='textColor' v-if="sub.OrderUsedStatus==-2" @click="routeToPay(bookInfo)">待支付</span>
            <span class='textColor' @click="routerReserve(sub.Code,sub.OrderUsedStatus)"  v-if="sub.OrderUsedStatus==-1">去预约</span>
            <span v-else>{{sub.OrderUsedStatusName}}</span>
            <span class="textColor" v-if="sub.MainOrderNo" @click="$router.push('/reserveDetails?OrderNO='+sub.MainOrderNo+'&QGOrderNo='+bookInfo.QGOrderNo+'&Code='+sub.Code)">查看</span>
            <span class="textColor" v-if="sub.CanCancel&&!sub.MainOrderNo" @click="cancel(sub,$event,index)">退款</span>
          </div>
				</div>
			</div>
    </div>
      <div class="book-comfirming" v-if="isBookCancel">
        <div class='f-modal'>
          <div class='f-modal-head'>提示</div>
          <div class='f-modal-body'>
            <p>正在取消订单，请稍候</p>
          </div>
        </div>
      </div>
    <Cancel :option="cancelData" @select="cancelData.select"></Cancel>
		<transition name="slide">
			<invoice v-if="isInvoiceBox==true" @changeFilter="changeFilter" @offInvoice="offInvoice" :orderMsg="bookInfo" :Currency="bookInfo.Currency"></invoice>
		</transition>
	</div>
</template>
<script>
import Invoice from "./../invoice/invoice.vue";
import Cancel from "./../common/cmpnt/cancel.vue";
import Clipboard from "clipboard";
export default {
  name: "bookDetails",
  components: {
    Cancel,
    Invoice
  },
  data() {
    return {
      bookInfo: {},
      isLoading: true, //是否显示loading
      isInvoiceBox: false, //显示发票页面
      isBookCancel:false,
      source: "",
      OrderTypeId: "",
      HAPI: this.Api.getOrderDetails,
      OAPI: this.Api.getOnlinePackageOrderDetails,
      OrderNO: "",
      cancelData: {
        show: false,
        title: "取消订单",
        content: "确定取消该订单吗？",
        token: "",
        select: token => {
          this.cancelOrder(token);
        }
      },
    };
  },
  methods: {
    cancel(item, $event, index) {
      var that = this
      $event.stopPropagation();
      if(index>=0){
        that.cancelData.token = that.bookInfo.SubOrders[index].Token;
        that.cancelData.show = true;
      }else {
        that.cancelData.token = that.bookInfo.Token;
        that.cancelData.show = true;
      }
    },
    cancelOrder(token) {
      var that = this;
      var param = {
        Token: token
      };
      that.isBookCancel = true;
      that.cancelData.show = false;
      that
        .postRequest({
          url: that.Api.cancelOnlinePackageOrder,
          params: param
        })
        .then(res => {
          that.isBookCancel = false;
          if (res && res.IsSuccess) {
            that.error({ title: "提示", content: "订单取消成功"},function(){
              that.getOrderDetails()
            });
          }else {
            that.error({ title: "提示", content: res.Msg || "取消失败" });
          }
        });
    },
    routerReserve(code,status){
      if(status!=-1)return
      this.dao.set("ReserveData", JSON.stringify(this.bookInfo));
      this.$router.push('/onlineReserve?Code='+code)
    },
    Back() {
      if (this.source&&this.bookInfo.OrderType==0) {
        this.$router.push("/myOrder");
      }else if (this.source&&!this.bookInfo.OrderType) {
        this.$router.push("/myOrder?type=pre&typeId=1");
      } else {
        this.$router.push("/");
      }
    },
    copyOrderNumber() {
      var clipboard = new Clipboard(".copyOrderNumber");
      var that = this;
      clipboard.on("success", e => {
        that.$alert("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        that.$alert("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    // 开发票 按钮
    openInvoice() {
      this.isInvoiceBox = true;
    },
    offInvoice() {
      this.isInvoiceBox = false;
    },
    // 再次预定
    bookAgain() {
      var obj = {
        HotelID: this.bookInfo.HotelID,
        ProductType: 0,
        From: 1,
        CheckIn: this.getDate(0),
        CheckOut: this.getDate(1),
        RoomCount: 1,
        AdultCount: 2,
        ChildrenCount: 0,
        ChildrenAges: [5, 5],
        MyCityRegionID: ""
      };
      
      if(this.bookInfo.IsForeignOrder){
        this.dao.set("frHotelDetailsParams", JSON.stringify(obj));
        this.$router.push("/frHotelDetails");
      }else{
        this.dao.set("hotelDetailsParams", JSON.stringify(obj));
        this.$router.push("/hotelDetails");
      }
      
    },
    // 立即支付
    routeToPay(order) {
      // 如果是酒店订单
      if (order.OrderType == 0) {
        this.dao.set("thisBookingOrderNO", order.OrderNO);
        this.$router.push({
          path: "/wxPay",
          query: { OrderNO: order.OrderNO, flag: true }
        });
        return;
      } else {
        this.dao.set("thisBookingOrderNO", order.QGOrderNo);
        this.$router.push({
          path: "/wxPay",
          query: { OrderNO: order.QGOrderNo }
        });
      }
    },
    getOrderDetails() {
      var that = this;
      var myAPI = "";
      var param = {
        orderNO: that.OrderNO
      };
      if (that.OrderTypeId == 0) {
        myAPI = that.HAPI;
      } else {
        myAPI = that.OAPI;
      }
      that.isLoading = true;
      that
        .getRequest({
          url: myAPI,
          params: param
        })
        .then(res => {
          that.isLoading = false;
          if (res && res.IsSuccess) {
            that.bookInfo = res.Result;
          } else {
            that.error({ title: "提示", content: res.Msg || "加载失败" });
            // that.$router.push("/");
          }
        });
    }
  },
  mounted() {
    this.OrderNO = this.$route.query.OrderNO;
    if(this.$route.query.OrderTypeId){
      this.OrderTypeId = this.$route.query.OrderTypeId;
    }else{
      if(this.OrderNO.indexOf('CN')>-1){
        this.OrderTypeId = 0
      }else{
        this.OrderTypeId = 1
      }
    }
    
    if (this.$route.query.source) {
      this.source = this.$route.query.source;
    }
    this.getOrderDetails();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/book/bookDetails.vue